var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopSearchArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 42,
    height: 28,
    viewBox: "0 0 42 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2041",
    "data-name": "Rectangle 2041",
    width: 42,
    height: 28,
    transform: "translate(16372 8360)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_30",
    "data-name": "Mask Group 30",
    transform: "translate(-16372 -8360)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Polygon_4",
    "data-name": "Polygon 4",
    transform: "translate(16364 8359)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 54.07967758178711 39.50000762939453 L 3.920328140258789 39.50000762939453 C 3.345077991485596 39.50000762939453 2.845578193664551 39.19408798217773 2.584158182144165 38.68166732788086 C 2.322738170623779 38.16924667358398 2.368247985839844 37.58527755737305 2.705908060073853 37.11954879760742 L 27.78557777404785 2.526888132095337 C 28.07101058959961 2.133182048797607 28.51366996765137 1.907348036766052 28.99995613098145 1.907348036766052 C 28.99998474121094 1.907348036766052 28.99995803833008 1.907348036766052 28.9999885559082 1.907348036766052 C 29.48630714416504 1.90733802318573 29.92894744873047 2.133157968521118 30.21439743041992 2.526888132095337 L 55.29408645629883 37.11954879760742 C 55.63174819946289 37.58527755737305 55.6772575378418 38.16924667358398 55.41583633422852 38.68166732788086 C 55.15442657470703 39.19408798217773 54.65492630004883 39.50000762939453 54.07967758178711 39.50000762939453 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 28.9999885559082 2.407337188720703 C 28.67577743530273 2.407337188720703 28.38068771362305 2.557876586914063 28.19037818908691 2.820377349853516 L 3.110706329345703 37.41303634643555 C 2.885608673095703 37.72351837158203 2.855266571044922 38.11283874511719 3.029537200927734 38.45444869995117 C 3.203819274902344 38.79605865478516 3.536819458007813 39.00000762939453 3.920318603515625 39.00000762939453 L 54.07967758178711 39.00000762939453 C 54.46317672729492 39.00000762939453 54.79617691040039 38.79605865478516 54.970458984375 38.45444869995117 C 55.14472961425781 38.11283874511719 55.11438751220703 37.72351837158203 54.88928985595703 37.41303634643555 L 29.80959892272949 2.820377349853516 C 29.61928749084473 2.557888031005859 29.32419776916504 2.407337188720703 28.9999885559082 2.407337188720703 M 28.9999885559082 1.407344818115234 C 29.60996627807617 1.407344818115234 30.21994400024414 1.682697296142578 30.61920738220215 2.233409881591797 L 55.69889831542969 36.82606887817383 C 56.65753936767578 38.1483268737793 55.71288681030273 40.00000762939453 54.07967758178711 40.00000762939453 L 3.920318603515625 40.00000762939453 C 2.287109375 40.00000762939453 1.342456817626953 38.14833831787109 2.301097869873047 36.82606887817383 L 27.38076782226563 2.233409881591797 C 27.78003311157227 1.682697296142578 28.39001083374023 1.407344818115234 28.9999885559082 1.407344818115234 Z",
    stroke: "none",
    fill: "#3f2566"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopSearchArrow);
export default __webpack_public_path__ + "static/media/top-search-arrow.d46dc90c2bb1261332564833a8f429b0.svg";
export { ForwardRef as ReactComponent };